export default "__VITE_ASSET__o3QbxMkY__"